(function () {
  function getConfig() {
    return window.EclatOkendoReviewGiveaway || {};
  }

  function addOkendoGiveawayText() {
    const config = getConfig();

    if (!config.html) return;

    const containers = document.querySelectorAll('.oke-w-reviews-writeReview');

    containers.forEach(function (container) {
      const writeReviewButton = container.querySelector('a.oke-w-writeReview');

      if (!writeReviewButton) return;
      if (container.querySelector('.eclat-okendo-review-giveaway-note')) return;

      const note = document.createElement('span');
      note.className = 'eclat-okendo-review-giveaway-note';
      note.innerHTML = config.html;

      writeReviewButton.insertAdjacentElement('afterend', note);
    });
  }

  addOkendoGiveawayText();

  const observer = new MutationObserver(function () {
    addOkendoGiveawayText();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();